import { render, staticRenderFns } from "./uom-editor.vue?vue&type=template&id=b41e1288"
import script from "./uom-editor.vue?vue&type=script&lang=js"
export * from "./uom-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports